import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  padding: 24px 30px;
  @media (max-width: 767px) {
    padding-left: 16px;
    padding-right: 16px;
  }
  gap: 10px;
  justify-content: space-between;
  align-items: flex-start;
  min-width: 0;
  flex-direction: column;

  @media (min-width: 1280px) {
    flex-direction: row;
  }

  & .left-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
  }

  & .high-line {
    min-width: 0;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: space-between;

    & .card {
      width: 100%;
    }
  }

  & .line {
    > * {
      flex: 1 1 250px;
    }
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
  }

  & .card {
    min-width: 0;
    width: 100%;
    min-height: 170px;
    background: var(--color-surface);
    box-shadow: 0 8px 10px var(--color-shadow);
    border-radius: 10px;
    padding: 20px;
    position: relative;

    &.card-deadline {
      height: auto;
      max-height: 670px;
      width: 100%;
      @media (min-width: 1280px) {
        width: 280px;
        flex-shrink: 0;
      }
    }

    &.card-jobsList {
      height: auto;
      max-height: 490px;
    }

    & .title {
      color: var(--color-text-muted);
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      line-height: 150%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    & .superTitle {
      color: var(--color-link);
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    & .subTitle {
      color: var(--color-accent);
      font-style: normal;
      font-weight: 600;
      font-size: 36px;
      line-height: 47px;
      margin-top: -2px;
    }

    & .description {
      color: var(--color-text-muted);
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      line-height: 150%;
    }
  }
`;
